<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="30%"  custom-class="dialogHeight dialogPaddingTop0" :before-close="handleClose">
    <department_tree 
    v-if="dialogVisible"
    @node-click="onNodeClick" 
    :invalid="invalid" 
    @checkAll="checkAll"  
    :departments="departments"
    :haveChange="haveChange"
    @changeStatus="changeStatus"/>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel" size="small">{{$t('cancel')}}</el-button>
      <!-- <el-button @click="onDelete" size="small">删 除</el-button> -->

      <el-button type="primary" @click="onOk" size="small" v-if="!invalid">{{$t('confirm')}}</el-button>
      <el-button type="primary" @click="onAddDeptOk" size="small" v-if="invalid">{{$t('confirm')}}</el-button>

    </span>
  </el-dialog>
</template>

<script>
import department_tree from "@/components/department_tree.vue";
export default {
  components: {
    department_tree
  },
  props: ["visible","invalid","departments","onedepart"],
  data() {
    return {
      checkDept:{},
      checkedAll:[],
      haveChange:false,
      title:"",
    };
  },
  created(){
    if(this.invalid){
      this.title="添加部门"
    }else{
      this.title="选择上级部门"
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },

  methods: {
    changeStatus(val){
      this.haveChange=val;
    },
    onNodeClick(dept) {
      this.checkDept=dept;
    },
    checkAll(all){
      this.checkedAll=all;
    },
    onOk(){
      if(this.checkDept=={}){
        this.$message({
          showClose: true,
          message: "必须选择一个部门",
          type: "error"
        });
        return false;
      }else{
        console.log(this.checkDept)
        if(this.checkDept.editFlag==="true"){
          this.dialogVisible = false;
          this.$emit("select-ok", this.checkDept);
        }else{
          this.$message({type:"warning",message:"您无此部门的管理权限，无法进行操作"})
        }
      }

      
    },
    onAddDeptOk(){     
      if(this.onedepart==1){//this.onedepart父级prop传递过来的标识符 只能添加一个部门
        if(this.checkedAll.length>1){
           this.$message({type:"warning",message:"只能添加一个部门"})
           return
        }
      }
      this.dialogVisible = false;
      if(this.checkedAll.length==0 && !this.haveChange){
        this.checkedAll=this.departments;
      }
      this.$emit("select-ok", this.checkedAll);
    },
    onCancel(){
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>